import api from "./api";

export default class FileApi {
  static async fileDownload(data) {
    return await api.post(`api/common/file/download`, data, {
      responseType: "blob",
    });
  }
  static async fileUpload(data, path) {
    return await api.fileForm(`api/common/file/upload`, data, "post", path);
  }
}
